export default "__VITE_ASSET__Mz05LvfR__"